module.exports = __webpack_public_path__ + "static/media/church.9fdc1e5c.jpg";